<template>
  <div>          
    <registration-request-layout 
      :requestId="requestId"
      :getRegistrationRequestById="workflowService.getKennelRegistrationRequestById"
      :onRequestProcessed="onRequestProcessed"
      :approveRegistrationRequest="onApproved"
      :denyRegistrationRequest="workflowService.denyKennelRequest"
      :signSignatureByAdminFn="workflowService.signKennelRequestSignatureByAdmin"
      :markPaidByAdminFn="workflowService.markKennelPaidByAdmin"
      :setRegistrationData="onSetRegistrationData"
    >
      <v-row class="ml-3">
        <AdminCoownersList
          :hideContactInfo="true"
          :owners="registration.owners"
          :ownershipType="kennelOwnershipType"
        />
      </v-row>
      <div class="mt-5 ml-3">    
        <h3>Choose Kennel Name</h3>
        <p>
          <v-radio-group mandatory row v-model="selectedName" :disabled="!!registration && (!!registration.approvedName || registration.status == 'RequestDenied' || registration.status == 'WorkflowComplete')">
            <v-radio
                color="primary" 
                :label="'First choice: ' + registration.firstName"
                :value="registration.firstName"
            ></v-radio>
            <v-radio
                color="primary" 
                :label="'Second choice: ' + registration.secondName"
                :value="registration.secondName"
            ></v-radio>
          </v-radio-group>
          <KennelSimilarNamesDialog :kennelSearchPhrase="selectedName" />
        </p>
      </div>   
    </registration-request-layout>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import KennelSimilarNamesDialog from "@/components/Admin/KennelSimilarNamesDialog.vue";
import AdminCoownersList, { OwnershipType } from "@/components/Admin/AdminCoownersList.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

export default Vue.extend({
  name: 'KennelRegistrationCard',
  props: {
    requestId: { type: Number },
  },
  components: {
    RegistrationRequestLayout,
    KennelSimilarNamesDialog,
    AdminCoownersList,
  },
  data: function() {
    return {
      registration: {
        workflowGuid: "",
        requestId: 0,
        firstName: "",
        secondName: "",
        owners: []
      } as any,
      showDenialReasonDialog: false,
      searchResults: [],
      selectedName: "",
      processingRequest: false,
    };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
    kennelOwnershipType: function() {
      return OwnershipType.Kennel;
    },
  },
  methods: {
    onSetRegistrationData(registration: any) {
      this.registration = registration;
      this.selectedName = registration.approvedName ?? registration.firstName;
    },
    onApproved(guid: string, requestId: number) {
      return workflowService.approveKennelRequest(guid, requestId, this.selectedName);
    },
    onRequestProcessed: function (requestId: number) {
      this.$navigate({ path: '/admin/registration/kennels' });
    },
  }
});
</script>
